export default "__VITE_ASSET__y33dsgqS__"